import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <Header />

      <main>
        <div className="main_box1">
          <Link to="/shop">
            <img alt="Dog and cat exploring Pawluna enrichment products" src="/main/main1.jpg" />
          </Link>
        </div>

        {/* 2 */}
        <div className="main_box2">
          <div className="enrichment-intro">
            <h2>
              Enrichment helps dogs feel better, stay fitter,
              <br />
              and behave better.
            </h2>
            <div className="icon-row">
              <div className="icon-item">
                <div className="icon-circle">
                  <img src="/main/main2-1.svg" alt="Happier mind" />
                </div>
                <span>Happier mind</span>
              </div>
              <div className="icon-item">
                <div className="icon-circle">
                  <img src="/main/main2-2.svg" alt="More Energy" />
                </div>
                <span>More Energy</span>
              </div>
              <div className="icon-item">
                <div className="icon-circle">
                  <img src="/main/main2-3.svg" alt="Good manners" />
                </div>
                <span>Good manners</span>
              </div>
            </div>

            <h3>Discover Our Enrichment Products</h3>
          </div>

          <div className="enrichment-banners">
            <div className="banner-card cognitive">
              <div className="banner-content">
                <h2>
                  Cognitive Enrichment <span className="new-badge">New</span>
                </h2>
                <p className="subtitle">
                  The modular puzzle you and your pup play as a team!
                </p>
                <ul>
                  <li>Fresh puzzles every time</li>
                  <li>Four difficulty levels in one</li>
                  <li>Fully detachable, dishwasher-safe</li>
                </ul>
                <Link
                  to="/shop"
                  onClick={toTop}
                  className="btn btn-white-blue"
                >
                  LunaPath collection &gt;
                </Link>
              </div>
              <div className="banner-image">
                <img src="/img/1010.jpg" alt="Cognitive enrichment maze bowl" />
              </div>
            </div>

            <div className="banner-card sensory">
              <div className="banner-content">
                <h2>Sensory Enrichment</h2>
                <p className="subtitle">
                  Multi-sensory toys that beat boredom and build focus
                </p>
                <ul>
                  <li>Stimulates sight, smell, taste and touch</li>
                  <li>Lick, chew and play</li>
                  <li>Textured geometric design</li>
                </ul>
                <Link
                  to="/shop"
                  onClick={toTop}
                  className="btn btn-yellow-black"
                >
                  Flex &amp; Play collection &gt;
                </Link>
              </div>
              <div className="banner-image">
                <img src="/img/1016.jpg" alt="Sensory enrichment lick and fetch disc" />
              </div>
            </div>

            <div className="banner-card mental">
              <div className="banner-content">
                <h2>Mental Enrichment</h2>
                <p className="subtitle">
                  Modular interactive feeder that keeps minds engaged
                </p>
                <ul>
                  <li>Adjustable challenge levels</li>
                  <li>Food-safe and BPA-Free</li>
                  <li>Dishwasher-safe</li>
                </ul>
                <Link
                  to="/shop"
                  onClick={toTop}
                  className="btn btn-white-orange"
                >
                  LunaPath collection &gt;
                </Link>
              </div>
              <div className="banner-image">
                <img src="/img/1012.jpg" alt="Mental enrichment puzzle feeder" />
              </div>
            </div>

            <div className="banner-card food">
              <div className="banner-content">
                <h2>Food Enrichment</h2>
                <p className="subtitle">
                  Lick mats and plates that extend mealtime and soothe stress
                </p>
                <ul>
                  <li>Textured surface for longer licking</li>
                  <li>Secure, anti-slip grip</li>
                  <li>Dishwasher-safe (Top rack)</li>
                </ul>
                <Link
                  to="/shop"
                  onClick={toTop}
                  className="btn btn-white-black"
                >
                  Lick &amp; Slow collection &gt;
                </Link>
              </div>
              <div className="banner-image">
                <img src="/img/102.jpg" alt="Food enrichment lick mat" />
              </div>
            </div>
          </div>
        </div>

        {/* 4 */}
        <div className="main_box4">
          <h3>Everyday Enrichment Ideas</h3>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="card-image">
                <img src="/main/main4-1.jpg" alt="Blue the GSD with toy" />
              </div>
              <div className="card-content">
                <p>
                  Spread a pet-safe favorite across the textured surface to turn
                  a quick snack into a calmer, more engaging activity.
                </p>
                <span className="feedback-source">
                  Pawluna enrichment guide
                </span>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="card-image">
                <img
                  src="/main/main4-2.jpg"
                  alt="Cats and dog with slow feeder"
                />
              </div>
              <div className="card-content">
                <p>
                  Choose a comfortably sized feeder and supervise shared spaces
                  when cats and dogs enjoy enrichment nearby.
                </p>
                <span className="feedback-source">
                  Pawluna enrichment guide
                </span>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="card-image">
                <img src="/main/main4-3.jpg" alt="Milo with paw bowl" />
              </div>
              <div className="card-content">
                <p>
                  Begin with open pathways, then introduce more challenging
                  routes as your pet learns to forage at a steady pace.
                </p>
                <span className="feedback-source">
                  Pawluna enrichment guide
                </span>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
